import styled from 'styled-components/native'
import { atlTheme } from '../../atlTheme'
import { CPF_CONSTRAINT, PASSWORD_CONSTRAINT } from '../../constants/formsConstraints'

export const SubContainer = styled.View`
  flex: 1;
`
export const LoginFormContainer = styled.SafeAreaView`
  background-color: ${atlTheme.ColorSurface};
  flex: 1;
  flex-direction: column;
`

export const SignUpLabel = styled.Text`
  font-family: ${atlTheme.FontFamilyBrand};
  font-weight: ${atlTheme.FontWeight500};
  font-size: ${atlTheme.FontSizeAuxiliary}px;
  line-height: ${atlTheme.LineHeightHeading}px;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  color: ${atlTheme.ColorMediumContrast};
  font-size: 14px;
`
export const SignUpActionLabel = styled.Text`
  font-family: ${atlTheme.FontFamilyBrand};
  font-weight: ${atlTheme.FontWeight500};
  font-size: ${atlTheme.FontSizeAuxiliary}px;
  line-height: ${atlTheme.LineHeightHeading}px;
  align-items: center;
  text-align: center;
  text-transform: uppercase;
  color: ${atlTheme.ColorBrand2Default};
  margin-left: ${atlTheme.SpacingAtomic}px;
  font-size: 14px;
`

export const formName = 'LoginForm'

export const formFields = {
  CPF: 'cpf',
  PASSWORD: 'password',
}

export const constraints = {
  [formFields.CPF]: CPF_CONSTRAINT,
  [formFields.PASSWORD]: PASSWORD_CONSTRAINT,
}

export enum graphQLErrorsCode {
  USER_NOT_FOUND = 'USER_NOT_FOUND',
  INVALID_PASSWORD = 'INVALID_PASSWORD',
}

export const extraScrollHeight = 40
